<template>
  <div class="spirit-wrapper">
    <iframe
      title="Spirit PDF as HTML"
      class="spirit-frame"
      src="/spirit.html"
      loading="lazy"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SpiritPage',
};
</script>

<style scoped>
.spirit-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f7fbff;
  padding: 12px 0;
}

.spirit-frame {
  width: 100%;
  min-height: 95vh;
  border: none;
  border-radius: 18px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14);
  background: white;
}
</style>

